'use client';
import { useState } from 'react';

var useClipboard = function(param) {
    var _ref = param === void 0 ? {} : param, _ref_timeout = _ref.timeout, timeout = _ref_timeout === void 0 ? 2000 : _ref_timeout;
    var _useState = useState(null), error = _useState[0], setError = _useState[1];
    var _useState1 = useState(false), copied = _useState1[0], setCopied = _useState1[1];
    var _useState2 = useState(), copyTimeout = _useState2[0], setCopyTimeout = _useState2[1];
    var handleCopyResult = function(value) {
        clearTimeout(copyTimeout);
        setCopyTimeout(setTimeout(function() {
            return setCopied(false);
        }, timeout));
        setCopied(value);
    };
    var copy = function(valueToCopy) {
        if ("clipboard" in navigator) {
            navigator.clipboard.writeText(valueToCopy).then(function() {
                return handleCopyResult(true);
            }).catch(function(error) {
                return setError(error);
            });
        } else {
            setError(new Error("useClipboard: navigator.clipboard is not supported"));
        }
    };
    var reset = function() {
        setCopied(false);
        setError(null);
        clearTimeout(copyTimeout);
    };
    return {
        copy: copy,
        reset: reset,
        error: error,
        copied: copied
    };
};

export { useClipboard };
